import { c as _c } from "react/compiler-runtime";
import { GradientBackground } from './gradient-background';
import { LayoutFooter } from './layout/layout-footer';
import { LayoutHeader } from './layout/layout-header';
type MainLayoutProps = {
  children: React.ReactNode;
};
export function MainLayout(props) {
  const $ = _c(8);
  const {
    children
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LayoutHeader />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== children) {
    t1 = <main id="main-content" tabIndex={-1} className="mx-auto mb-16 w-full max-w-5xl flex-1 px-6 py-24 outline-none sm:px-8">{children}</main>;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LayoutFooter />;
    t3 = <GradientBackground />;
    t4 = <GradientBackground position="bottom" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1) {
    t5 = <>{t0}{t1}{t2}{t3}{t4}</>;
    $[6] = t1;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}